export default __webpack_public_path__ + "static/media/AQR-token.7d4255f7.svg";